import { Component } from '@angular/core';

@Component({
  selector: 'myre-nav-menu-item',
  styleUrls: ['./navbar-menu-item.component.scss'],
  templateUrl: './navbar-menu-item.component.html',
})
export class NavbarMenuItemComponent {}
